import React from 'react';
import PropTypes from 'prop-types';
import {
  EVBox,
  EVTypography,
} from '@eagleview/ev-comp-library';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import useStyles from '../ViewProfileDialogStyle';

const ViewDetails = (props) => {
  const classes = useStyles();
  const { t, userProfileDetails } = props;

  return (
    <EVBox id="view-only-details" className={classes.detailsContainer}>
      <EVBox className={classes.field}>
        <EVTypography className={classes.label}>{t('FirstName')}</EVTypography>
        <EVTypography className={classes.value}>{userProfileDetails.firstName}</EVTypography>
      </EVBox>
      <EVBox className={classes.field}>
        <EVTypography className={classes.label}>{t('LastName')}</EVTypography>
        <EVTypography className={classes.value}>{userProfileDetails.lastName}</EVTypography>
      </EVBox>
      <EVBox className={classes.field}>
        <EVTypography className={classes.label}>{t('Email')}</EVTypography>
        <EVTypography className={classes.value}>{userProfileDetails.userName}</EVTypography>
      </EVBox>
      <EVBox className={classes.field}>
        <EVTypography className={classes.label}>{t('JobTitle')}</EVTypography>
        <EVTypography className={classes.value}>
          {userProfileDetails.title ? userProfileDetails.title : ''}
        </EVTypography>
      </EVBox>
      <EVBox className={classes.field}>
        <EVTypography className={classes.label}>{t('MobileNumber')}</EVTypography>
        <EVTypography className={classes.value}>
          {userProfileDetails.phoneNumber ? `+${userProfileDetails.countryCode} ${userProfileDetails.phoneNumber}` : ''}
        </EVTypography>
      </EVBox>
    </EVBox>
  );
};

ViewDetails.propTypes = {
  t: PropTypes.func.isRequired,
  userProfileDetails: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    userName: PropTypes.string,
    title: PropTypes.string,
    countryCode: PropTypes.string,
    phoneNumber: PropTypes.string,
  }).isRequired,
};

export default compose(withTranslation())(ViewDetails);
